import React, { ReactNode } from "react";
import { CheckIcon, CopyIcon } from "@primer/octicons-react";
import useClipboard from "~/hooks/use-copy-to-clipboard";

export function ClipboardLabel(props: {
  children: ReactNode;
  content?: string | null;
  iconSize?: number;
  /** Accessible name for the copy button. */
  label?: string;
}) {
  const [isCopied, copyToClipboard] = useClipboard(2000);

  let str = props.content ?? "";
  if (!str) {
    if (typeof props.children === "string") {
      str = props.children;
    } else {
      React.Children.forEach(props.children, (child) => {
        if (React.isValidElement(child) && child.type === "a") {
          str = child.props.children;
        }
      });
    }
  }

  const copy = () => copyToClipboard(str, "text/plain");

  if (!props.children) return null;

  return (
    <span
      onClick={typeof props.children === "string" ? copy : undefined}
      style={{
        cursor: typeof props.children === "string" ? "pointer" : undefined,
      }}
    >
      {props.children}
      <button
        type="button"
        className="cl-button"
        aria-label={props.label ?? "Copy to clipboard"}
        onClick={typeof props.children === "string" ? undefined : copy}
      >
        {!isCopied ? (
          <CopyIcon verticalAlign="unset" size={props.iconSize} />
        ) : (
          <CheckIcon verticalAlign="unset" size={props.iconSize} />
        )}
      </button>
      <style jsx>{`
        .cl-button {
          cursor: pointer;
          background: none;
          border: none;
          color: currentcolor;
        }
      `}</style>
    </span>
  );
}
